export default "__VITE_ASSET__BUyXUTJP__"